import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ReactLoading from 'react-loading';
import { Button, Table, Modal, ModalBody, ModalHeader } from 'reactstrap';

import { formatCurrency } from '../../utilities/helpers';
import { ADMIN } from './constants';

const TABLE_HEAD_CELLS = ['Bidder', 'Time', 'Bid Amount'];

const BidHistoryModal = ({ lotNumber, isOpen, onClose, onBidCancel }) => {
  const { bidHistory, lotBidHistoryLoading, canCancelBid } = useSelector(state => state.bulkBidding);

  return (
    <Modal isOpen={isOpen} className="bid-history-modal" toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <h3>Lot {lotNumber} Bid History</h3>
      </ModalHeader>
      <ModalBody>
        {lotBidHistoryLoading ? (
          <ReactLoading size="sm" className="loading-spinner m-auto" type="spin" color="black" />
        ) : (
          <Table bordered className="position-relative fixed-header">
            <thead>
              <tr>
                {TABLE_HEAD_CELLS.map(cell => (
                  <th key={cell}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {bidHistory.map(bid => (
                <tr key={bid.time} className="bid-history-lot">
                  <td>{bid.bidder}</td>
                  <td>{bid.time}</td>
                  <td className="d-flex justify-content-between align-items-center">
                    <span>{formatCurrency(bid.bidAmount)}</span>
                    {
                      bid.bidder === ADMIN && canCancelBid && (
                      <Button color="link" onClick={() => onBidCancel(bid.orderBidRef)}>
                        Cancel
                      </Button>
                      )
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
    </Modal>
  );
};

BidHistoryModal.propTypes = {
  lotNumber: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

BidHistoryModal.defaultProps = {
  lotNumber: null,
  isOpen: false,
  onClose: Function.prototype
};

export default BidHistoryModal;
